module.exports = __webpack_public_path__ + "static/media/textured-background.f4b562c1.jpg";